<template>
	<div class="container-fluid bg-white">
		<safety-toolbar heading="Employee Certificates" icon="fa-id-card"></safety-toolbar>

		<collapsible-panel :external-toggle="panelToggle" v-on:panelRetract="panelToggle = false">
			<template slot="panel">

				<h4>Filtering</h4>
				
				<field label="By Certificate"
					col-class="stacked"
					v-model="certFilter"
					:params="{type:'select-multi',options:certOptions}">
				</field>

				<field label="By Employee"
					col-class="stacked"
					v-model="employeeFilter"
					:params="{type:'select-multi',options:userOptions(false,employees)}">
				</field>

				<field label="Expires Before"
					col-class="stacked"
					v-model="expiresBeforeFilter"
					:params="{type:'date'}">
				</field>
			</template>
			<template slot="main">

				<div class="d-flex flex-row align-items-center pt-3 pb-2 button-row" style="margin-top: -15px;">

					<button 
						class="btn btn-light mr-2" 
						v-on:click="panelToggle = true">
						<i class="fa fa-filter"></i>
						Filter
					</button>

					<a href="#" v-on:click.prevent="exportCerts" class="btn btn-light mr-2">
						<i class="fa fa-download"></i>
						Export to CSV
					</a>

					<label class="mr-2 mb-0">
						<input type="checkbox" v-model="$store.certificatesShowShortName">
						Display Acroynms/Short Names
					</label>

				</div>

				<div v-if="employees.length" class="table-matrix">
					<div class="left-column flex-table" :class="{'filtering-open': panelToggle}">

						<div class="flex-table-header">
							<div class="flex-table-row">
								<div class="flex-table-cell">
									<div class="header-cell-inner left-column-header">
										Employee
									</div>
								</div>
							</div>
						</div>

						<div class="flex-table-body" ref="leftColumnBody">
							<div v-for="emp in mutatedEmployees" v-if="emp.hasCerts" class="flex-table-row">
								<div class="flex-table-cell header-cell"><router-link :to="'/employee/'+emp.slug+'/certificates'">{{emp.userName}}</router-link></div>
							</div>
						</div>
					</div>
					<div class="main-table">
						<div class="flex-table" :style="{width: flexTableWidth}">

							<div class="flex-table-header">
								<div class="flex-table-row">
									<div v-for="cert in filteredCerts" class="flex-table-cell" :title="cert.cert_name">
										<div class="header-cell-inner">
											<div class="header-cell-inner-2x">
												<div class="header-cell-inner-3x">{{$store.certificatesShowShortName ? cert.short_name : cert.cert_name}}</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="flex-table-body" ref="mainTable" v-on:scroll="scrollLeftColumn">
								<div v-for="emp in mutatedEmployees" v-if="emp.hasCerts" class="flex-table-row">
									<div class="flex-table-cell" v-for="cert in emp.companyCerts">

										<div v-if="cert.expiry" class="cert-tile alert" :class="{
												'alert-success': cert.expiry_days >= expiryWarning || cert.expiry == 'Never',
												'alert-warning': cert.expiry_days < expiryWarning && cert.expiry_days > expiryDanger,
												'alert-danger': cert.expiry_days < expiryDanger && cert.expiry != 'Never'
											}">
											<a href="#" v-on:click.prevent="openCert(cert,emp)">
												<i class="fa" :class="{
													'fa-exclamation-triangle cert-danger':cert.expiry_days < expiryDanger && cert.expiry != 'Never',
													'fa-clock cert-warning': cert.expiry_days < expiryWarning && cert.expiry_days > expiryDanger,
													'fa-thumbs-up cert-green': cert.expiry_days >= expiryWarning || cert.expiry == 'Never'
												}"></i>

												<!--<div v-if="cert.expiry != 'Never'">
													<div>Expires {{cert.expiry}}</div>
													<div>
														({{cert.expiry_days}} days)
														<i class="fa fa-external-link"></i>
													</div>
												</div>
												<div v-else class="cert-green">
													<div>Issued {{cert.issue}}</div>
													<div>
														never expires
														<i class="fa fa-external-link"></i>
													</div>
												</div>
												<div v-if="cert.approved == 0" class="text-info">
													Pending employer approval
													<i class="fa fa-external-link"></i>
												</div>-->

												<div v-if="cert.expiry != 'Never'">
													{{cert.expiry_days}}d
												</div>
												<div v-else class="cert-green" title="never expires">
													N.E.
												</div>
												<div v-if="cert.approved == 0" class="text-info">
													Pending employer approval
												</div>

											</a>
										</div>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</collapsible-panel>

		<modal-dialog :modal-visible="certModal.visible"
			title="Certificate"
			modal-size="modal-xl"
			v-on:closeModal="certModal.visible = false"
			:submit-visible="false"
			cancel-button-text="Done">

			<certificate-card
				:readonly="true"
				:no-card="true"
				:uncollapsible="true"
				:cert="certModal.cert"
				:company-certs="certs">
			</certificate-card>

		</modal-dialog>
	</div>
</template>
<script type="text/javascript">
import SafetyToolbar from "./SafetyToolbar"

import CertificateCard from "@/components/CertificateCard"
import ModalDialog from "@/components/ModalDialog"
import TableList from "@/components/TableList"
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import Field from "@/components/Field"

export default {
	name: "TrainingCertificates",
	components: {
		SafetyToolbar,
		TableList,
		CollapsiblePanel,
		Field,
		CertificateCard,
		ModalDialog
	},
	data() {
		return {
			certs: [],
			employees: [],
			certFilter: [],
			employeeFilter: [],
			expiresBeforeFilter: null,
			expiryDanger: 30,
			expiryWarning: 90,
			panelToggle: false,
			certModal: {
				visible: false,
				cert: null
			}
		}
	},
	computed: {
		flexTableWidth() {
			return (window.innerWidth > 600) ? ((this.filteredCerts.length + 1) * 82) + 'px' : '100%'
		},
		fields() {
			let vm = this

			let certs = this.certs.map(cert => {

				return {
					key: cert.id,
					label: cert.cert_name
				}
			})

			certs.unshift({
				key: 'userName',
				label: "Employee"
			})

			return certs
		},
		certOptions() {
			let vm = this

			return this.optionify(this.certs,"cert_name")
		},
		filteredCerts() {
			let vm = this

			return this.certs.filter(cert => vm.certFilter.length == 0 || vm.certFilter.indexOf(cert.id) >= 0)
		},
		mutatedEmployees() {
			let vm = this

			let emps = this.employees.map(emp => {

				emp.numCerts = 0

				let certs = []

				emp.hasCerts = false

				let empNumCerts = 0

				vm.filteredCerts.forEach(companyCert => {
					
					if ("UserCertificate" in emp && emp.UserCertificate) {
						let matchingCert = emp.UserCertificate.find(userCert => 'UserCompanyCertificate' in userCert && 
								userCert.UserCompanyCertificate.length > 0 && 
								userCert.UserCompanyCertificate[0].tenant_cert_id == companyCert.id &&
								userCert.archived == 0
							)

						if (matchingCert) {

							let expiry = matchingCert.expiry_date
							let expiry_days = vm.moment(expiry).diff(vm.moment(),"days")
							if (matchingCert.never_expires == 1) {
								expiry = "Never"
								expiry_days = false
							}

							let includeCert = true
							if (vm.expiresBeforeFilter && !vm.moment(matchingCert.expiry_date).isBefore(vm.expiresBeforeFilter)) 
								includeCert = false
							
							if (includeCert) {
								emp.hasCerts = true
								emp.numCerts++

								certs.push({
									id: matchingCert.id,
									expiry: expiry,
									issue: matchingCert.issue_date,
									approved: matchingCert.UserCompanyCertificate[0].user_cert_accepted,
									expiry_days: expiry_days
								})
							}
						}
						else {
							certs.push({
								id: null,
								expiry: "",
								issue: "",
								approved: null,
								expiry_days: ""
							})
						}
					}
					
				})

				emp.companyCerts = certs

				emp.userName = emp.first_name + " " + emp.last_name
				if (emp.userName.length > 18)
					emp.userName = emp.userName.slice(0, 18) + "..."
				
				return emp
			})

			if (vm.employeeFilter.length > 0)
				emps = emps.filter(emp => vm.employeeFilter.indexOf(emp.id) >= 0 && emp.hasCerts)

			return emps
		}
	},
	methods: {
		scrollLeftColumn() {
			if ('leftColumnBody' in this.$refs) {

				this.$refs.leftColumnBody.style.marginTop = "-" + this.$refs.mainTable.scrollTop + "px"
			}
		},
		exportCerts() {

			let rows = []

			let headerRow = this.filteredCerts.map(cert => this.$store.certificatesShowShortName ? cert.short_name : cert.cert_name)

			headerRow.unshift("Employee Name")

			rows = this.mutatedEmployees.filter(emp => emp.hasCerts).map(emp => {
				let certs = emp.companyCerts.map(cert => {
					if (cert.expiry == 'Never')
						return "Never Expires"
					else
						return cert.expiry
				})

				certs.unshift(emp.first_name+" "+emp.last_name)

				return certs
			})

			rows.unshift(headerRow)

			this.exportToCSV("EmployeeCertificates.csv",rows)
		},
		openCert(cert,emp) {
			let fullCert = emp.UserCertificate.find(userCert => userCert.id == cert.id)

			this.certModal.visible = true
			this.certModal.cert = fullCert

			let vm = this

			this.spinner(true)

			this.fetchCertificate(fullCert.slug).then(response => {
				vm.spinner(false)
				if (response.success) {
					vm.certModal.cert = response.data
				}
			})

			this.$forceUpdate()
		},
		fetchCertificate(slug) {
			let vm = this

			let params = {
				include: [
					"UserCompanyCertificate",
					"CertificateUpload",
					"User"
				]
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("UserCertificate/find/"+slug,params).then(response => {
					resolve(response)
				})
			})
		},
		fetchData() {
			let vm = this

			vm.spinner(true)

			let userParam = {
				include: [{model:"UserCertificate",include:["UserCompanyCertificate"]}]
			}

			let promises = [
				this.getJSON("CompanyCertificate/get"),
				this.getJSON("User/get",userParam)
			]

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				vm.certs = responses[0].data
				vm.employees = responses[1].data
			})
		}
	},
	created() {
		this.fetchData()
		document.body.style.overflow = 'hidden'
	},
	destroyed() {
		document.body.style.overflow = 'auto'
	}
}
</script>

<style type="text/css" scoped>
	/*.cert-green {
		color: green;
	}

	.cert-warning {
		color: #ff8600;
	}

	.cert-danger {
		color: red
	}*/


	/* abandon all hope ye who enters */

	.button-row {
		position: relative;
		z-index: 3;
		background-color: white;
	}

	.flex-table-body .flex-table-row .flex-table-cell {
		height: 28px;
	}

	.table-matrix {
		display: block;
		overflow-y: hidden;
		overflow-x: hidden;
	}

	.left-column-header {
		display: flex;
		align-items: center;
		font-size: 11pt!important;
	}

	.left-column {
		min-width: 180px;
		width: 180px;
		position: absolute;
		left: 0;
		outline: white solid 2px;
		background-color: white;
		z-index: 2;
	}

	.left-column .flex-table-header {
		background-color: white;
		z-index: 2;
		position: relative;
	}

	.left-column .flex-table-body {
		z-index: 1;
		position: relative;
	}

	.filtering-open {
		margin-left: 300px;
	}

	.table-matrix .main-table {
		margin-left: 180px;
		margin-right: -15px;
		z-index: 1;
		overflow-x: auto;
	}

	.table-matrix .main-table .flex-table .flex-table-body {
		overflow-x: hidden;
		overflow-y: auto;
	}

	.flex-table-body {
		max-height: calc(100vh - 330px);
	}

	.flex-table-row {
		display: flex;
		flex-direction: row;
		border-bottom: 1px solid #e0e0e0;
		align-items: stretch;
	}

	.flex-table-cell {
		flex-basis: 75px;
		flex-grow: 0;
		flex-shrink: 0;
		margin: 2px;
		display: flex;
    	align-items: center;
	}

	.flex-table-header .flex-table-cell.header-cell,
	.flex-table-cell.header-cell {
		flex-basis: 200px;
		border-right: none;
	}

	.flex-table-header, .header-cell {
		font-weight: 600;
	}

	.flex-table-header .flex-table-cell {
		flex-basis: 75px;
		width: 75px;
		border-right: none;
	}

	.flex-table-header .flex-table-cell .header-cell-inner {
		height: 150px;
		transform: translate(15px, -5px);
		font-size: 10pt;
	}

	.flex-table-header .flex-table-cell .header-cell-inner-2x {
		transform: rotate(-45deg);
		line-height: 1.1;
		border-bottom: 1px dotted #e0e0e0;
		width: 350px;
		margin-top: -5px;
	}

	.flex-table-header .flex-table-cell .header-cell-inner-3x {
		padding-bottom: 20px;
		position: relative;
		left: -25px;
	}


	.cert-tile.alert {
		padding: 3px;
		box-shadow: 0 3px 1px -2px grey;
		border-radius: .25rem;
		border: 1px solid rgba(0,0,0,.125);
		width: 100%;
		margin-bottom: 0;
		font-size: 10pt;
	}

	.cert-tile a {
		display: flex;
		flex-direction: row;
		color: inherit;
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;
	}

	.cert-tile a i {
		margin-right: 5px;
	}

	.cert-tile a:hover {
		text-decoration: none;
	}

	.cert-tile .text-info {
		flex-grow: 1;
		text-align: center;
		font-size: 10pt;
	}

	.cert-tile a .fa-external-link {
		display: none;
	}

	.cert-tile a:hover .fa-external-link {
		display: inline;
	}


	@media (min-width: 800px) {

		.container-fluid {
			padding-right: 0;
		}

	}

	@media (max-width: 800px) {

		.table-matrix {
			display: flex;
			overflow-x: auto;
			overflow-y: hidden;
		}

		.left-column {
			position: relative;
		}

		.table-matrix .main-table {
			overflow-x: visible;
			margin-left: 0;
			width: 100%!important;
		}

		.flex-table-body {
			max-height: calc(100vh - 380px);
		}

		.filtering-open {
			margin-left: 0;
		}

		body {
			overflow-y: hidden;
			overflow-x: hidden;
		}
	}

</style>